import { OpeningHourViewSchema } from '@fsf/types';
import { _ } from '@ngx-translate/core';
import { z } from 'zod';

export const OPENING_HOUR_TYPES = [
  'weekdays',
  'changed_times',
  'closed_days',
] as const;
export type OpeningHourTypeKind = (typeof OPENING_HOUR_TYPES)[number];

export const WEEKDAYS = [
  'mon',
  'tue',
  'wed',
  'thu',
  'fri',
  'sat',
  'sun',
] as const;
export type Weekday = (typeof WEEKDAYS)[number];

export type OpeningHour = z.infer<typeof OpeningHourViewSchema>;

const timeOrNull = z
  .string()
  .regex(/^\d{2}:\d{2}(:\d{2})?$/, { message: 'validation.invalid' })
  .nullable()
  .optional();

const dateOrIso = z
  .string()
  .min(1, { message: 'validation.required' });

export const StoreOpeningHourSchema = z.object({
  type: z.enum(OPENING_HOUR_TYPES, { message: 'validation.invalidOption' }),
  date_start: dateOrIso,
  date_end: z.string().nullable().optional(),
  time_start_mon: timeOrNull,
  time_end_mon: timeOrNull,
  time_start_tue: timeOrNull,
  time_end_tue: timeOrNull,
  time_start_wed: timeOrNull,
  time_end_wed: timeOrNull,
  time_start_thu: timeOrNull,
  time_end_thu: timeOrNull,
  time_start_fri: timeOrNull,
  time_end_fri: timeOrNull,
  time_start_sat: timeOrNull,
  time_end_sat: timeOrNull,
  time_start_sun: timeOrNull,
  time_end_sun: timeOrNull,
  time_start: timeOrNull,
  time_end: timeOrNull,
  notes: z.string().nullable().optional(),
});

export type StoreOpeningHourPayload = z.infer<typeof StoreOpeningHourSchema>;
export const UpdateOpeningHourSchema = StoreOpeningHourSchema.partial();
export type UpdateOpeningHourPayload = z.infer<typeof UpdateOpeningHourSchema>;

export const openingHourTranslations = _([
  'catalog.openingHours.add',
  'catalog.openingHours.edit',
  'catalog.openingHours.empty',
  'catalog.openingHours.save',
  'catalog.openingHours.cancel',
  'catalog.openingHours.deleteConfirmHeader',
  'catalog.openingHours.deleteConfirmMessage',
  'catalog.openingHours.created',
  'catalog.openingHours.updated',
  'catalog.openingHours.deleted',
  'catalog.openingHours.createError',
  'catalog.openingHours.updateError',
  'catalog.openingHours.deleteError',
  'catalog.openingHours.types.weekdays',
  'catalog.openingHours.types.changed_times',
  'catalog.openingHours.types.closed_days',
  'catalog.openingHours.fields.type',
  'catalog.openingHours.fields.dateStart',
  'catalog.openingHours.fields.dateEnd',
  'catalog.openingHours.fields.timeStart',
  'catalog.openingHours.fields.timeEnd',
  'catalog.openingHours.fields.notes',
  'catalog.openingHours.weekdays.mon',
  'catalog.openingHours.weekdays.tue',
  'catalog.openingHours.weekdays.wed',
  'catalog.openingHours.weekdays.thu',
  'catalog.openingHours.weekdays.fri',
  'catalog.openingHours.weekdays.sat',
  'catalog.openingHours.weekdays.sun',
]);
